// Constants for printer COMMAND
// these commands are based on ESC/POS - Epson Standard
export const PRINTER_COMMAND = {
  // cut the paper
  cut: '\x1b\x69',

  // break
  br: '\x0A',

  // line spacing
  default_line_spacing: '\x1b\x32',

  // feed
  f02: '\x1b\x64\x02',
  f03: '\x1b\x64\x03',
  f04: '\x1b\x64\x04',
  f05: '\x1b\x64\x05',
  f06: '\x1b\x64\x06',
  f07: '\x1b\x64\x07',
  f08: '\x1b\x64\x08',
  f09: '\x1b\x64\x09',
  f10: '\x1b\x64\x10',

  // underline
  u00: '\x1b\x2d\x00',
  u01: '\x1b\x2d\x01',
  u02: '\x1b\x2d\x02',

  // bold
  b00: '\x1b\x45\x00',
  b01: '\x1b\x45\x01',

  //height
  h00: '\x1d\x21\x00',
  h01: '\x1d\x21\x01',
  h02: '\x1d\x21\x02',
  h03: '\x1d\x21\x03',
  h04: '\x1d\x21\x04',
  h05: '\x1d\x21\x05',
  h06: '\x1d\x21\x06',
  h07: '\x1d\x21\x07',

  // width
  w00: '\x1d\x21\x00',
  w01: '\x1d\x21\x10',
  w02: '\x1d\x21\x20',
  w03: '\x1d\x21\x30',
  w04: '\x1d\x21\x40',
  w05: '\x1d\x21\x50',
  w06: '\x1d\x21\x60',
  w07: '\x1d\x21\x70',

  // CHAR SIZE WIDTH/HEIGHT
  // standard
  wh00: '\x1d\x21\x00',

  // double
  wh11: '\x1d\x21\x11',
  wh12: '\x1d\x21\x12',
  wh13: '\x1d\x21\x13',
  wh14: '\x1d\x21\x14',
  wh15: '\x1d\x21\x15',
  wh16: '\x1d\x21\x16',
  wh17: '\x1d\x21\x17',

  wh21: '\x1d\x21\x21',
  wh22: '\x1d\x21\x22',
  wh23: '\x1d\x21\x23',
  wh24: '\x1d\x21\x24',
  wh25: '\x1d\x21\x25',
  wh26: '\x1d\x21\x26',
  wh27: '\x1d\x21\x27',

  wh31: '\x1d\x21\x31',
  wh32: '\x1d\x21\x32',
  wh33: '\x1d\x21\x33',
  wh34: '\x1d\x21\x34',
  wh35: '\x1d\x21\x35',
  wh36: '\x1d\x21\x36',
  wh37: '\x1d\x21\x37',

  wh41: '\x1d\x21\x41',
  wh42: '\x1d\x21\x42',
  wh43: '\x1d\x21\x43',
  wh44: '\x1d\x21\x44',
  wh45: '\x1d\x21\x45',
  wh46: '\x1d\x21\x46',
  wh47: '\x1d\x21\x47',

  wh51: '\x1d\x21\x51',
  wh52: '\x1d\x21\x52',
  wh53: '\x1d\x21\x53',
  wh54: '\x1d\x21\x54',
  wh55: '\x1d\x21\x55',
  wh56: '\x1d\x21\x56',
  wh57: '\x1d\x21\x57',
};

export enum PRINTER_STATUS {
  OK = 'OK',
  NOT_FOUND = 'printer_not_found',

  // CLOSED SOCKET ERRORS
  SOCKET_CLOSED_1 = 'socket_closed_write_failed',
  SOCKET_CLOSED_2 = 'socket_closed_write_unable_to_open',
  SOCKET_CLOSED_3 = 'socket_closed_write_failed_to_open',
  SOCKET_CLOSED_4 = 'socket_closed_write_catch',
  SOCKET_CLOSED_5 = 'socket_closed_status_failed',

  COVER_OPEN = 'cover_open',
  PAPER_OUT = 'paper_out',
  FEED_PRESSED = 'feed_pressed',

  KICKOUT_LOW = 'kickout_low',
  OFFLINE = 'offline',
  UNREACHABLE = 'unreachable',
  BUSY = 'busy',
  RECOVERING = 'recovering',
  UNKNOWN = 'unknown',
  ERROR_OCCURRED = 'error_occurred',

  /** FN - 3 - ERROR OCCURRED */
  RECOVERABLE_ERROR = 'recoverable_error_occurred',
  AUTOCUTTER_ERROR = 'autocutter_error_occurred',
  UNRECOVERABLE_ERROR = 'unrecoverable_error_occurred',
  AUTORECOVERABLE_ERROR = 'autorecoverable_error_occurred',

  CHECKING = 'checking',
}

export const PRINTER_MESSAGE = {
  BLUETOOTH_DISABLED: 'bluetoothDisabled',
  DISCONNECTED: 'disconnected',
  CONNECTED: 'connected',
  NO_BLUETOOTH_DEVICES: 'emptyDevices',
  DEVICE_SNIFF_FAILED: 'failedGettingDevices',
  NO_PRINTER_SELECTED: 'printerNotSelected',
  CONNECTION_FAILED: 'failedConnectingToPrinter',
  CORDOVA_NOT_AVAILABLE: 'cordovaNotAvailable',
  PRINTER_NOT_ACTIVE: 'printerNotActive',
  PRINTER_NO_PAIRED: 'printerNotPaired',
  EMPTY_DATA: 'emptyData',
  FAILED_TO_CONNECT_IN_TIME: 'failedToConnectInTime',
};

export enum PRINTER_TYPE {
  BT = 'bluetooth',
  IP = 'ethernet',
}

export const PRINT_TRIGGER = {
  INFO: 'info',
  INFO_ETA: 'info eta',
  ETA_SELECTOR: 'eta selector',
  PRESERVICE: 'preservice',
  AUTO_SET_ETA: 'auto set eta',
  PREORDER_PROMPT: 'preorder prompt',
  PRINT_ALL_TODAY: 'print all today',
  AUTO_PRINT_DINEIN: 'auto print dine in',
  DOCKET_DETAILS: 'docket details',
  PRINT_RETRY: 'print retry',
};
